import React, {Component} from 'react';
import DataTable from 'react-data-table-component';
import DynamicModal from '../../../../../components/DynamicModal/DynamicModal';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import TableSearchFields from '../../../../../components/TableSearchFields/TableSearchFields';
import {http_call, func_privileges} from '../../../../../libs/utils';
import './css/style.css';
import PubSub from 'pubsub-js';
import {confirm} from 'react-bootstrap-confirmation';




export default class ItemType extends Component {
    constructor(props) {
        let func = {"add": 125, 'del': 126, 'edit': 127, 'get': 124}
        func = func_privileges(func)
        super(props);
        this.state = {
            "func": func,
            name: "事项类型",
            "modal_show": false,
            "modal_title": "",
            "modal_rules": [],
            "modal_submit_title": "",
            "modal_submit_callback": "",
            column: [
                {
                    "name": "ID",
                    "selector": row => row.id,
                },
                {
                    "name": "事项类型名称",
                    "selector": row => row.mc
                },
                {
                    "name": "操作",
                    "width": "100px",
                    "selector": row => {
                        return <div style={{"minWidth": "150px"}}>
                            { this.state.func.del ?<FontAwesomeIcon title='删除' icon="fa fa-trash"
                                             size='xl'
                                             style={{
                                                 'color': 'red',
                                                 "cursor": "pointer"
                                             }} onClick={e => {
                                this.del_sxlx(row.id)
                            }}/>:null}
                            { this.state.func.edit ?<FontAwesomeIcon title='编辑' icon="fa fa-pen-to-square"
                                             size='xl'
                                             style={{
                                                 'color': '#d38269',
                                                 "cursor": "pointer",
                                                 "marginLeft": '5px'
                                             }} onClick={e => {
                                this.edit_sxlx(e, row.id)
                            }}/>:null}
                        </div>
                    }
                },

            ],
            "search_rule": [
                {
                    "label_name": "类型名称",
                    "type": "text",
                    "id": "search_mc",
                    "value": "",
                    "must": false,
                    "nullable": false,
                },
            ],
            selectRows: {},
        }
    }

    componentDidMount() {
        this.get_all_sxlx()
    }

    add_sxlx = (e) => {
        this.setState({
            "modal_show": true,
            "modal_title": "新增事项类型",
            "modal_rules": [
                {
                    "label_name": "事项类型名称",
                    "type": "text",
                    "id": "mc",
                    "value": "",
                    "must": true,
                    "nullable": false,
                },
            ],
            "modal_submit_title": "提交",
            "modal_submit_callback": (e, data) => {
                http_call('/jzzwdt/itemtype', 'POST', data).then(res => {
                    let alert_info;
                    if (res.RTN_CODE === '01') {
                        alert_info = {
                            "title": "提示",
                            "content": res.RTN_MSG,
                            "type": "success",
                            "position": "top-right",
                            "dismiss": 1000,
                        }
                        this.setState({"modal_show": false})
                        this.get_all_sxlx()
                    } else {
                        alert_info = {
                            "title": "提示",
                            "content": res.RTN_MSG,
                            "type": "error",
                            "position": "top-right",
                            "dismiss": 1000,
                        }
                    }
                    PubSub.publish('AlertNotify', alert_info);
                })
            },
        });
    }

    edit_sxlx= (e, id) => {
        PubSub.publish('Loding', true);
        http_call('/jzzwdt/itemtype', 'GET', {'id': id}).then(res => {
            PubSub.publish('Loding');
            this.setState({
                "modal_show": true,
                "modal_title": "修改事项类型",
                "modal_rules": [
                    {
                        "label_name": "事项类型id",
                        "type": "hidden",
                        "id": "id",
                        "value": id,
                        "must": true,
                        "nullable": false,
                    },
                    {
                        "label_name": "事项类型名称",
                        "type": "text",
                        "id": "mc",
                        "value": res.DATA[0].mc,
                        "must": true,
                        "nullable": false,
                    },
                ],
                "modal_submit_title": "提交",
                "modal_submit_callback": (e, data) => {
                    console.log(data);
                    http_call('/jzzwdt/itemtype/edit', 'POST', data).then(res => {
                        let alert_info;
                        if (res.RTN_CODE === '01') {
                            alert_info = {
                                "title": "提示",
                                "content": res.RTN_MSG,
                                "type": "success",
                                "position": "top-right",
                                "dismiss": 1000,
                            }
                            this.setState({"modal_show": false})
                            this.get_all_sxlx()
                        } else {
                            alert_info = {
                                "title": "提示",
                                "content": res.RTN_MSG,
                                "type": "error",
                                "position": "top-right",
                                "dismiss": 1000,
                            }
                        }
                        PubSub.publish('AlertNotify', alert_info);
                    })
                },
            });
        })
    }

    del_sxlx= async (id) => {
        const result = await confirm(<h2 className='text-center text-danger'>确认删除?</h2>,
            {
                "title": <div><h4 className='text-center text-warning'>警告</h4></div>,
                "okText": "确认",
                okButtonStyle: 'warning',
                "cancelText": "取消"
            });
        if (result) {
            http_call('/jzzwdt/itemtype/delete', 'POST', {'id': id}).then(res => {
                let alert_info;
                if (res.RTN_CODE === '01') {
                    alert_info = {
                        "title": "提示",
                        "content": res.RTN_MSG,
                        "type": "success",
                        "position": "top-right",
                        "dismiss": 1000,
                    }
                    this.setState({"modal_show": false})
                    this.get_all_sxlx()
                } else {
                    alert_info = {
                        "title": "提示",
                        "content": res.RTN_MSG,
                        "type": "error",
                        "position": "top-right",
                        "dismiss": 1000,
                    }
                }
                PubSub.publish('AlertNotify', alert_info);
            })
        }
    }

    get_all_sxlx = () => {
        PubSub.publish('Loding', true);
        http_call('/jzzwdt/itemtype', 'GET').then(res => {
            this.setState({"tableData": res.DATA})
            PubSub.publish('Loding');
        })
    }

    inquiry_sxlx = (data) => {
        PubSub.publish('Loding', true);
        let DATA = {}
        Object.keys(data).forEach((key)=>{
            DATA[key.replace('search_', '')] = data[key];
        })
        http_call('/jzzwdt/itemtype', 'GET', DATA).then(res => {
            this.setState({"tableData": res.DATA})
            PubSub.publish('Loding');
        })
    }

    render() {
        return (
            <div className='page-inner'>
                <div className="page-header">
                    <h4 className="page-title">{this.state.name}</h4>
                    <ul className="breadcrumbs">
                        <li className="nav-home">
                            <span>
                                <FontAwesomeIcon icon="fa fa-home"/>
                            </span>
                        </li>

                        <li className="separator">
                            <FontAwesomeIcon icon="fa-solid fa-greater-than"/>
                        </li>
                        <li className="nav-item">
                            <span>{this.state.name}</span>
                        </li>
                    </ul>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div style={{"marginLeft": '5px', "marginBottom": '5px'}}>
                                { this.state.func.add ?<button className='btn btn-primary btn-xs'
                                        onClick={e => {
                                            this.add_sxlx(e);
                                        }
                                        }>新增事项类型
                                </button>:null}
                                <TableSearchFields rule={this.state.search_rule} onSearch={(data) => {this.inquiry_sxlx(data)}}/>
                            </div>
                            <DataTable
                                noDataComponent=<h1
                                style={{"textAlign": "center", "marginBottom": '20px'}}>暂无数据</h1>
                            columns={this.state.column}
                            data={this.state.tableData}
                            selectableRows
                            progressPending={this.state.pending}
                            pagination
                            paginationComponentOptions = {{
                                rowsPerPageText:'每页行数:',
                                rangeSeparatorText: '/',
                                selectAllRowsItem: true,
                                selectAllRowsItemText: '全部'
                            }}
                            fixedHeader
                            fixedHeaderScrollHeight={"100vh"}
                            theme=""
                            onSelectedRowsChange={(rows) => {
                            this.setState({"selectRows": rows})
                        }}
                            />
                        </div>
                    </div>
                </div>
                {this.state.modal_show ?
                    <DynamicModal show={this.state.modal_show}
                                  rules={this.state.modal_rules}
                                  title={this.state.modal_title}
                                  submit_title={this.state.modal_submit_title}
                                  close_callback={e => {
                                      this.setState({"modal_show": false})
                                  }}
                                  submit_callback={this.state.modal_submit_callback}
                    />
                    : null
                }
            </div>
        );
    }
}
